import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './FooterControls.scss';

export default function FooterControl(props) {
   // console.log('FooterControl called..... ');
   const [value, setValue] = React.useState(45);
   const [prevDeltaScene, setPrevDeltaScene] = React.useState(0);
   const [zoombarValue, setZoombarValue] = React.useState(0);

   const handleChange = (event, newValue) => {
      setValue(newValue);
   };
   var slider = window.UiUtils.domElement.sliderRange ?? document.querySelector("#sliderRange");
   window.updateSlider = function(){

      slider = window.UiUtils.domElement.sliderRange ?? document.querySelector("#sliderRange");
      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         // setTimeout(function () { 
            slider.value = window.scene._nav.getZoomFactor(); 
            window.onSliderContainerClick()  
         // }, 700);
      }
   }
useEffect(() => {
  const slider = document.getElementById('sliderRange');
  if (slider) {
    slider.style.setProperty('--value', `${value}%`);
    slider.value = value;
  }
}, [value]);

  // Expose setter globally so mouseWheel can update React state
   useEffect(() => {
      window.setSliderValue = setValue;
      return () => {
         delete window.setSliderValue;
      };
   }, []);
window.onSliderContainerClick = () => {
  const slider = document.getElementById('sliderRange');
  if (slider) {
    const val = parseFloat(slider.value);
    setValue(val); // React state update
   // console.log('onSliderContainerClick val ', val);
    // Remove direct style manipulation here; handle in useEffect instead

    // Call zoom function after state update (optional: useEffect can handle this)
   //  window.scene._nav.NavChangeDolly(undefined, val / 100);
  }
};

const handleZoomChange = (e, newValue) => {
   const selectedHotspotId = window.selectedConfig.currentSelectedHotspot;
   window.activeHotspots(selectedHotspotId);
   if (window.config.navigationDisabled == true) return;
  const slider = window.UiUtils.domElement.sliderRange ?? document.querySelector("#sliderRange");
  let val;
  if (e && e.target) {
    val = e.target.value;
  } else if (newValue !== undefined) {
    val = newValue;
  } else {
    return;
  }
  val = Number(val); // ensure numeric
  setValue(val);
  if (slider) {
    slider.value = val;
    slider.style.setProperty('--value', `${val}%`);
  }
  window.scene._nav.NavChangeDolly(undefined, val / 100);
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.hidePopUpandHotspot();
      window.hotspot = '';

      // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
      //    window.zoonOutCamStatus = false;

         // this code is used to hide pop on mouse down
         // var allPopup = document.querySelector('.popup.active');
         // if (allPopup != null) {
         //    allPopup.classList.remove('active');
         // }
         // window.UiUtils.handleZoomoutCam(window.zoomOutSequence)
         window.UiUtils.handleZoomoutCam();
      // }
      if (e) {
         window.scene._nav.NavChangeDolly(undefined, e.target.value / 100);
      } else {
         window.scene._nav.NavChangeDolly(undefined, newValue / 100);
         slider.value = newValue;
      }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }

      window.hidePopUpandHotspot();

      if (typeof window.updateSlider === "function") window.updateSlider();
   };

   //only for mob
   const [camData, setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;

   const onZoomIn = (e) => {
      const selectedHotspotId = window.selectedConfig.currentSelectedHotspot;
    window.activeHotspots(selectedHotspotId);
      window.clearCalloutCanvas();
      const slider = window.UiUtils.domElement.sliderRange ?? document.querySelector("#sliderRange");
      if (!slider) return;

      const currentValue = parseFloat(slider.value);
      const newValue = Math.max(currentValue - 1, 0);

      if (window.scene._nav.getZoomFactor() > 0) {
         handleZoomChange(null, newValue);
      }

      window.hidePopUpandHotspot();
      window.UiUtils.handleZoomoutCam();
   };

   const onZoomOut = (e) => {
      const selectedHotspotId = window.selectedConfig.currentSelectedHotspot;
    window.activeHotspots(selectedHotspotId);
      window.clearCalloutCanvas();
      const slider = window.UiUtils.domElement.sliderRange ?? document.querySelector("#sliderRange");
      if (!slider) return;

      const currentValue = parseFloat(slider.value);
      const newValue = Math.min(currentValue + 1, 100);

      if (window.scene._nav.getZoomFactor() < 100) {
         handleZoomChange(null, newValue);
      }

      window.hidePopUpandHotspot();
      window.UiUtils.handleZoomoutCam();
   };

   const onLeft = () => {
      window.clearCalloutCanvas();
      window.scene._nav.NavRotation([0, 0], [7, 0]);
      window.hotspot = '';
      window.hidePopUpandHotspot();
      window.UiUtils.handleZoomoutCam();
      window.scene.clearRefine();
      // if (window.selectedButton != 'accordion_interiorFeatur') {
      //    window.selectedButton = '';
      // }
      // window.scene.clearRefine();
      // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
      //    window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         // var allPopup = document.querySelector('.popup.active');
         // if (allPopup != null) {
         //    allPopup.classList.remove('active');
         // }
         
      // }
   }
   const onRight = () => {
      window.clearCalloutCanvas();
      window.scene._nav.NavRotation([0, 0], [-7, 0]);
      window.hotspot = '';
      window.hidePopUpandHotspot();
      window.UiUtils.handleZoomoutCam();
      window.scene.clearRefine();
      // if (window.selectedButton != 'accordion_interiorFeatur') {
      //    window.selectedButton = '';
      // }
      // window.scene.clearRefine();
      // if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
      //    window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         // var allPopup = document.querySelector('.popup.active');
         // if (allPopup != null) {
         //    allPopup.classList.remove('active');
         // }
         
      // }
   }

   
//New code added 
var animStopped = true;
var conScreenControlHandlerCalled = false;

const onScreenControlHandler = (e) =>{
   // console.log('onScreenControlHandler called..... ', conScreenControlHandlerCalled, e.type, e);
   // if(conScreenControlHandlerCalled) return; // Throttle added of 300ms to allow complete the Footer control div animation 
   conScreenControlHandlerCalled = true;
   let onScreenControlsValueLocal = window.UiUtils.domElement.onScreenControlsValue ?? document.querySelector('#onScreenControlsValue');
   //onScreenControlsValueLocal.disabled = true;
   // console.log(e)

   // if(e.type === "keydown" && e.key === "Enter" && e.target.id === "onScreenControlsValue") {
      // onScreenControlsValueLocal.checked = !onScreenControlsValueLocal.checked;
   // }

   const isChecked = onScreenControlsValueLocal.checked;

   

   // console.log('isChecked ', window.UiUtils.domElement.onScreenControlsValue.checked);
   if(isChecked){
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';
         if(window.UiUtils.domElement.footerControls) window.UiUtils.domElement.footerControls.classList.add('active');
         window.UiUtils.domElement.onScreenControls.setAttribute('aria-checked', 'true');
         window.UiUtils.domElement.onScreenControlsValue.checked = true;
         // window.UiUtils.updateAriaLabel('onScreenControlHandlerkeyPress', window.UiUtils.domElement.onScreenControls, "checked")
   } else {
         window.animation1SwitchGlobal = 'off';
         window.animationSwitchVal = 'off';
         if(window.UiUtils.domElement.footerControls) window.UiUtils.domElement.footerControls.classList.remove('active');
         window.UiUtils.domElement.onScreenControls.setAttribute('aria-checked', 'false');
         window.UiUtils.domElement.onScreenControlsValue.checked = false;
         // window.UiUtils.domElement.onScreenControlsValue.checked = false;
         // window.UiUtils.updateAriaLabel('onScreenControlHandlerkeyPress', window.UiUtils.domElement.onScreenControls, "not checked")

         // setTimeout(function () {
         //     animStopped = true;
         //  }, 200);
   }

   // Throttle added of 300ms to allow complete the Footer control div animation 
   setTimeout(function(){
      conScreenControlHandlerCalled = false;
      onScreenControlsValueLocal.disabled = false;
      window.UiUtils.setFocusOnElement(window.UiUtils.domElement.onScreenControls);
   }, 300);
    
   if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('onScreenControlHandlerkeyPress', window.UiUtils.domElement.footerControls);
   if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaHidden('onScreenControlHandlerkeyPress', window.UiUtils.domElement.footerControls);
   // if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaLabel('onScreenControlHandlerkeyPress', window.UiUtils.domElement.footerControls);
}

const onScreenControlHandlerkeyPress = (e) => {
   if(e.type === "keydown" && e.key === "Enter") {
      window.UiUtils.domElement.onScreenControlsValue.checked = !window.UiUtils.domElement.onScreenControlsValue.checked;
      onScreenControlHandler(e);
   }
      
      
}


let { previousView,resetView,nextView } = { ...props.ui };
let { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...props.ui }

    /*Set tooltip top to adjuest position based on no. of lines */
    setTimeout(function(){
      
      let tooltiptext = document.querySelector('.tooltiptext');
      let tooltiptextHeight = 0;
      if(tooltiptext != null){
         const compStylestooltiptext = window.getComputedStyle(tooltiptext);
         tooltiptextHeight = parseInt(compStylestooltiptext.height);
         if(tooltiptextHeight == 27) tooltiptext.style.top = '0px';
         else if(tooltiptextHeight >= 30 && tooltiptextHeight <= 50 ) tooltiptext.style.top = '-8px';
         else if(tooltiptextHeight >= 51 && tooltiptextHeight <= 55 ) tooltiptext.style.top = '-16px';
         else if(tooltiptextHeight >= 56 && tooltiptextHeight <= 65 ) tooltiptext.style.top = '-25px';
         else if(tooltiptextHeight >= 66 && tooltiptextHeight <= 75 ) tooltiptext.style.top = '-37px';
      }
    },1000)
    /*Set tooltip top to adjuest position based on no. of lines end */
   //  console.log('FooterControl window.menuSubmenuTabindex ', window.menuSubmenuTabindex)
   //  console.log('FooterControl called..... ')

   return (
      <React.Fragment>
         {ReactDOM.createPortal(
            <div id='footerControls' className="footerControlsDesk">
               {/* <div className="threebtns"> */}
               <div className="zoombarandRotateContainer">
                  <button tabIndex="-1" data-tabindex={1} className='btn previousView threeButtons' aria-label="Previous view" id="previousView" variant="outlined" onClick={e => props.onPrevious(e)} >
                     <div className='icon'>
                        {/* <img alt="Previous view" src="./images/footerControls/previousred.png" /> */}
                     </div>
                     {/* <div className='text'>
                        {previousView !== undefined ? previousView : 'Previous View'}
                     </div> */}
                  </button>
                  <div id="sliderWrapper" className='sliderWrapper'>
                  <button tabIndex="-1" data-tabindex={1} aria-label="clickable zoom out" className='btn zoomIn' type="button" role="button" id="zoomIn" onClick={onZoomIn}><span className="minusIcon"></span></button>

                  <div id="zoomSliderContainer " className='zoombar'>
                     <div className="rangeslider" aria-hidden="true">
                     <div className="filledTrack" style={{ width: `calc(14.5px + (100% - 29px) * ${value} / 100)` }}></div>                     
                     <input type="range"  min="0"
                  max="100"
                  value={value} onChange={handleZoomChange}   onInput={handleZoomChange} id="sliderRange" />
                     </div>
                  </div>
                  <button tabIndex="-1" data-tabindex={1} aria-label="clickable zoom in" className='btn zoomOut' type="button" id="zoomOut" role="button" onClick={onZoomOut}><span className="plusIcon"></span></button>
                  </div>
                  <button tabIndex="-1" data-tabindex={1} className='btn nextView threeButtons' aria-label="Next view" id="nextView" variant="outlined" onClick={e => props.onNext(e)} expanded={props.expanded} >
                     <div className='icon'>
                        {/* <img alt="Next view" src="./images/footerControls/nextred.png" /> */}
                     </div>
                     {/* <div className='text'>
                        {nextView !== undefined ? nextView : 'Next View'}
                     </div> */}
                  </button> 
                  {/*we have updated structure as per new design*/}
               </div>
            </div>, document.getElementById('footerControlDesk')
         )}
      </React.Fragment>

   );
}
